import { Stack } from '@mui/material'
import { Box } from '@mui/system'
import _ from 'lodash'
import BottomBarIconButton from './BottomBarIconButton'
import ExpandableMenu, { ExpandableMenuItem } from './ExpendableMenu'

export type BottomBarLocalConsultationProps = {
  menuItems: ExpandableMenuItem[]
  mobileMenu: ExpandableMenuItem[]
  setMobileSelectedMenuItem: (id: string) => void
  setSelectedMenuItem: (id: string) => void
  selectedMenuItem: string
}

export function BottomBarLocalConsultation(props: BottomBarLocalConsultationProps) {
  const { menuItems, mobileMenu, setMobileSelectedMenuItem, setSelectedMenuItem, selectedMenuItem } = props
  const nonNestedMenuItems = _.filter(mobileMenu, ['isNested', false])
  const menuItemsCount = nonNestedMenuItems.length

  const renderMenuItems = (startIndex: number, endIndex: number) => {
    return nonNestedMenuItems.slice(startIndex, endIndex).map((menuItem) => (
      <Box key={menuItem.id}>
        <BottomBarIconButton
          icon={menuItem.icon}
          label={menuItem.label}
          onClick={() => setSelectedMenuItem(menuItem.id)}
          selected={selectedMenuItem === menuItem.id}
        />
      </Box>
    ))
  }

  return (

    <Stack
      sx={{
        position: 'fixed',
        bottom: 0,
        backgroundColor: 'white',
        width: '100%',
        height: '56px',
        borderTop: '1px solid #E0E0E0',
        zIndex: 1000,
      }}
      direction="row"
      alignItems="center"
      justifyContent="space-evenly"
    >
      {renderMenuItems(0, menuItemsCount)}
      <ExpandableMenu items={menuItems} onClick={(id) => setMobileSelectedMenuItem(id)} />
    </Stack>

  )
}
